
import React from "react";
import { BellIcon } from "@heroicons/react/24/outline";

export default function NotificationBell({ count = 0, onClick }) {

    return (
        <button
            className="relative p-2 rounded-full hover:bg-gray-100 transition focus:outline-none"
            onClick={onClick}
            aria-label="Notifications"
        >
            <BellIcon className="w-6 h-6 text-gray-700" />
            {count > 0 && (
                <span className="absolute top-1 right-1 bg-red-500 text-white text-xs rounded-full px-1.5 py-0.5 min-w-[18px] text-center">
                    {count}
                </span>
            )}
        </button>
    );
}
